import { render } from "./HelloWorld.vue?vue&type=template&id=d92fbc2e&scoped=true"
import script from "./HelloWorld.vue?vue&type=script&lang=js"
export * from "./HelloWorld.vue?vue&type=script&lang=js"

import "./HelloWorld.vue?vue&type=style&index=0&id=d92fbc2e&scoped=true&lang=css"

import exportComponent from "/home/runner/work/slowko_dnia/slowko_dnia/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d92fbc2e"]])

export default __exports__